export default "__VITE_ASSET__qS7YhEIg__"